import React, { useEffect, useState } from 'react'
import useWebData from '../../hooks/useWebData';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faAngleRight, faPlus } from '@fortawesome/free-solid-svg-icons';
import Button from '../../components/Button';
import AddIdentification from './AddIdentification';
import { getCustomer, getExistingustomer, post_Customer, put_Customer } from '../../services/customer';
import { getCustomersExtraInformationsByCustomerId } from '../../services/customerExtraInformation';
import PhoneNumberInput from '../../components/PhoneNumberInput';
import axios from 'axios';
import { baseURL, tenantId } from '../../config/api';
import useConfirm from '../../hooks/useConfirm';
import moment from 'moment';
import usePleaseWait from '../../hooks/usePleaseWait';
import EmailValidatedComponent from '../../components/EmailValidatedComponent';
import { CustomDateField } from '../../components/CustomDateField';
import { format } from 'date-fns';

type ExtraInformation = {
    id: number;
    idNumber: string;
    issueDate: string;
    exprationDate: string;
    filePath: string;
    idTypeId: string;
    customerId: number;
    type: string;
    imageSize: number,
};

type Props = {
    getDataFromCustomer: (customerId: number, localAddress: string) => void;
    selectedVehicleClass: any;
    setLocalAddress: (value: string) => void;
    localAddress: string;
    setCurrentPage: () => void;
    returnDate: string;
    pickupDate: string;
    customerId: number;
    existingEmail: string;
    setExistingEmail: (value: string) => void;
    existingBirthday: string;
    setExistingBirthday: (value: string) => void;
}

const Customer = ({ selectedVehicleClass,
    getDataFromCustomer,
    setLocalAddress,
    localAddress,
    setCurrentPage,
    returnDate,
    pickupDate,
    customerId,
    existingEmail,
    setExistingEmail,
    existingBirthday,
    setExistingBirthday,
}: Props) => {
    const { setPleasWaitPopup }: any = usePleaseWait();
    const { webData }: any = useWebData();
    const [existingCustomer, setExistingCustomer] = useState<boolean>(true);
    const { setConfirmPopup, setData: setConfirmData }: any = useConfirm();
    const [isCustomerCollapse, setIsCustomerCollapse] = useState<boolean>(true);
    const [firstName, setFirstName] = useState<string>("");
    const [lastName, setLastName] = useState<string>("");
    const [emailAddress, setEmailAddress] = useState<string>("");
    const [phoneNumber, setPhoneNumber] = useState<string>("");
    const [street, setStreet] = useState<string>("");
    const [street2, setStreet2] = useState<string>("");
    const [city, setCity] = useState<string>("");
    const [state, setState] = useState<string>("");
    const [zip, setzip] = useState<string>("");
    const [country, setCountry] = useState<string>("");
    const [birthday, setBirthday] = useState<string>("");
    const [isExtra, setIsExtra] = useState<boolean>(true);
    const [primaryKey, setPrimaryKey] = useState<number>(0);
    const [notFound, setNotFound] = useState<boolean>(false);
    const [extraRow, setExtraRow] = useState<any[]>([]);
    const [indexNumber, setIndexNumber] = useState<number>(0);

    useEffect(() => {
        if (customerId) {
            setPleasWaitPopup(true);
            getCustomer(customerId, tenantId)
                .then((data) => {
                    setPrimaryKey(data?.id);
                    setFirstName(data?.firstName);
                    setLastName(data?.lastName);
                    setEmailAddress(data?.emailAddress);
                    setPhoneNumber(data?.phoneNumber);
                    setStreet(data?.street);
                    setStreet2(data?.street2);
                    setCity(data?.city);
                    setState(data?.state);
                    setCountry(data?.country);
                    setzip(data?.zip);
                    setBirthday(data?.birthday?.split("T")[0]);
                    setPleasWaitPopup(false);
                })
                .catch(error => {
                    setPleasWaitPopup(false);
                    console.error(error);
                });
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customerId]);


    const handleAddExtraRow = () => {
        const data: ExtraInformation = {
            id: indexNumber + 1,
            idNumber: "",
            issueDate: "",
            exprationDate: "",
            filePath: "",
            idTypeId: "",
            customerId: primaryKey,
            type: "POST",
            imageSize: 0,
        };
        setIndexNumber(indexNumber + 1);
        setExtraRow((extraRow: ExtraInformation[]) => [...extraRow, data]);
    };

    const handleDeleteExtraRow = async (index: number) => {
        if (extraRow?.find((row: ExtraInformation) => row?.id === index)?.type?.split(" ")[0] === "PUT") {
            await axios
                .delete(`${baseURL}customerExtraInformation?id=${extraRow?.find((row: ExtraInformation) => row.id === index)?.type?.split(" ")[1]}&userId=${0}`, {
                    headers: {
                        'X-Tenant-ID': tenantId,
                    }
                })
                .then(() => {
                    const newRow: ExtraInformation[] = extraRow?.filter(
                        (row: ExtraInformation) => row?.id !== index
                    );
                    setExtraRow(newRow);
                })
                .catch((error) => {
                    console.error("Error:", error);
                });
        } else {
            const newRow: ExtraInformation[] = extraRow?.filter(
                (row: ExtraInformation) => row?.id !== index
            );
            setExtraRow(newRow);
        }
    };

    const changeOnExtraValue = (row: ExtraInformation) => {
        const updatedExtraRow = extraRow?.map((rowValue: ExtraInformation) => {
            return rowValue?.id === row?.id ? row : rowValue;
        })
        setExtraRow(updatedExtraRow);
    };

    const findCustomer = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (existingBirthday && moment(existingBirthday, "YYYY-MM-DD", true)?.isValid()) {
            setPleasWaitPopup(true);
            getExistingustomer(existingEmail, existingBirthday, tenantId)
                .then(data => {
                    setNotFound(false);
                    setPrimaryKey(data?.id);
                    setFirstName(data?.firstName);
                    setLastName(data?.lastName);
                    setEmailAddress(data?.emailAddress);
                    setPhoneNumber(data?.phoneNumber);
                    setStreet(data?.street);
                    setStreet2(data?.street2);
                    setCity(data?.city);
                    setState(data?.state);
                    setCountry(data?.country);
                    setzip(data?.zip);
                    setBirthday(data?.birthday?.split("T")[0]);
                    setPleasWaitPopup(false);
                })
                .catch(error => {
                    setPleasWaitPopup(false);
                    setNotFound(true);
                    console.error(error);
                });
        }

    }

    useEffect(() => {
        if (primaryKey > 0) {
            getCustomersExtraInformationsByCustomerId(primaryKey, tenantId)
                .then((data) => {
                    setExtraRow(() =>
                        data?.filter((value: any) => value?.idTypeId !== 0)
                            ?.map((item: ExtraInformation, index: number) => {
                                return {
                                    id: index + 1,
                                    idNumber: item?.idNumber,
                                    issueDate: format(new Date(item?.issueDate), "yyyy-MM-dd"),
                                    exprationDate: format(
                                        new Date(item?.exprationDate),
                                        "yyyy-MM-dd"
                                    ),
                                    filePath: item?.filePath,
                                    idTypeId: item?.idTypeId,
                                    customerId: item?.customerId,
                                    type: `PUT ${item?.id}`,
                                    imageSize: item?.imageSize,
                                };
                            })
                    );
                })
                .catch(error => console.error(error));

        } else {
            setIndexNumber(1);
            setExtraRow([]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [primaryKey, customerId])

    const calculateAge = (date: string) => {
        var today = new Date();
        var birthDate = new Date(date);
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    };

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (
            calculateAge(birthday) <
            selectedVehicleClass?.minimumRentalAllowedAge ||
            calculateAge(birthday) > selectedVehicleClass?.maxRentalAllowedAge
        ) {
            setConfirmData({
                title: 'Warning',
                summary: `You are not old enough to operate this vehicle!`,
                confirmBtn: 'Ok',
                isConfirm: (callback: any) => {
                    callback();
                }
            });

            setConfirmPopup(true);
            return;
        }

        if (extraRow?.length === 0) {
            setConfirmData({
                title: 'Warning',
                summary: "Please add customer extra info",
                confirmBtn: 'Ok',
                isConfirm: (callback: any) => {
                    callback();
                }
            });

            setConfirmPopup(true);
            return;
        }

        let hasInvalidDate = false;

        if (extraRow?.length > 0) {
            extraRow?.forEach((item: any) => {
                if (item?.issueDate && moment(item?.issueDate, "YYYY-MM-DD", true)?.isValid() && item?.exprationDate && moment(item?.exprationDate, "YYYY-MM-DD", true)?.isValid()) {
                    const returnDateTime = new Date(returnDate);
                    const exprationDate = new Date(item?.exprationDate);

                    const pickupDateTime = new Date(pickupDate);
                    const issuedDate = new Date(item?.issueDate);

                    if (exprationDate < issuedDate) {
                        setConfirmData({
                            title: 'Warning',
                            summary: `The expiration date for ID (${item?.idNumber}) cannot be earlier than the issued date.`,
                            confirmBtn: 'Ok',
                            isConfirm: (callback: any) => {
                                callback();
                            },
                        });

                        setConfirmPopup(true);
                        setPleasWaitPopup(false);
                        hasInvalidDate = true;
                        return;
                    }

                    if (exprationDate < returnDateTime) {
                        setConfirmData({
                            title: 'Warning',
                            summary: `The expiration date for ID (${item?.idNumber}) cannot be earlier than the return date and time.`,
                            confirmBtn: 'Ok',
                            isConfirm: (callback: any) => {
                                callback();
                            },
                        });

                        setConfirmPopup(true);
                        setPleasWaitPopup(false);
                        hasInvalidDate = true;
                        return;
                    }

                    if (issuedDate > pickupDateTime) {
                        setConfirmData({
                            title: 'Warning',
                            summary: `The issued date for ID (${item?.idNumber}) cannot be later than the pickup date and time.`,
                            confirmBtn: 'Ok',
                            isConfirm: (callback: any) => {
                                callback();
                            },
                        });

                        setConfirmPopup(true);
                        setPleasWaitPopup(false);
                        hasInvalidDate = true;
                        return;
                    }
                } else {
                    setConfirmData({
                        title: 'Warning',
                        summary: `Issued date and Expiration date format must be - ${webData?.dateFormat?.replace(/yyyy/g, 'YYYY')}`,
                        confirmBtn: 'Ok',
                        isConfirm: (callback: any) => {
                            callback();
                        },
                    });

                    setConfirmPopup(true);
                    setPleasWaitPopup(false);
                    hasInvalidDate = true;
                    return;
                }

            });
        }

        if (!hasInvalidDate) {
            if (primaryKey > 0) {
                updateTheExtraCustomer(primaryKey);
            } else {
                saveNewCustomer();
            }
        }
    };

    const updateTheExtraCustomer = async (id: number) => {
        setPleasWaitPopup(true);
        if (extraRow?.length > 0) {
            extraRow?.forEach(async (item: ExtraInformation, index: number) => {
                if (item?.type?.split(" ")[0] === "POST") {
                    await axios
                        .post(
                            `${baseURL}customerExtraInformation?userId=${0}`,
                            JSON.stringify({
                                idNumber: item?.idNumber,
                                issueDate: new Date(item?.issueDate),
                                exprationDate: new Date(item?.exprationDate),
                                filePath: item?.filePath,
                                idTypeId: item?.idTypeId,
                                customerId: item?.customerId,
                                imageSize: item?.imageSize,

                            }),
                            {
                                headers: {
                                    'X-Tenant-ID': tenantId,
                                    "Content-Type": "application/json"
                                },
                                withCredentials: true,
                            }
                        )
                        .then(() => {
                            if (extraRow?.length === (index + 1)) {
                                updateTheCustomer(id);
                            }
                        })
                        .catch((error) => console.error("Error:", error));
                } else if (item?.type?.split(" ")[0] === "PUT") {
                    await axios
                        .put(
                            `${baseURL}customerExtraInformation?userId=${0}`,
                            JSON.stringify({
                                id: item?.type?.split(" ")[1],
                                idNumber: item?.idNumber,
                                issueDate: new Date(item?.issueDate),
                                exprationDate: new Date(item?.exprationDate),
                                filePath: item?.filePath,
                                idTypeId: item?.idTypeId,
                                customerId: item?.customerId,
                                imageSize: item?.imageSize
                            }),
                            {
                                headers: {
                                    'X-Tenant-ID': tenantId,
                                    "Content-Type": "application/json"
                                },
                                withCredentials: true,
                            }
                        )
                        .then(() => {
                            if (extraRow?.length === (index + 1)) {
                                updateTheCustomer(id);
                            }
                        })
                        .catch((error) => console.error("Error:", error));
                } else {
                    if (extraRow?.length === (index + 1)) {
                        updateTheCustomer(id);
                    }
                }
            });
        } else {
            updateTheCustomer(id);
        }
    };

    const updateTheCustomer = async (id: number) => {
        put_Customer({
            id: id,
            firstName,
            lastName,
            emailAddress,
            phoneNumber,
            street,
            street2,
            city,
            state,
            country,
            zip,
            birthday: birthday
        }, 0, tenantId)
            .then(() => {
                setPleasWaitPopup(false);
                getDataFromCustomer(id, localAddress);
                setCurrentPage();
            })
            .catch((error) => {
                setPleasWaitPopup(false);
                console.error("Error:", error);
            });
    }

    const saveNewCustomer = async () => {
        setPleasWaitPopup(true);

        const customerExtraInformations = extraRow?.map((item: any) => {
            return {
                idNumber: item?.idNumber,
                issueDate: new Date(item?.issueDate),
                exprationDate: new Date(item?.exprationDate),
                filePath: item?.filePath,
                idTypeId: item?.idTypeId,
                customerId: item?.customerId,
                imageSize: item?.imageSize,
                uploadedAt: new Date(item?.uploadedAt),
                uploadedBy: item?.uploadedBy
            };
        });


        await post_Customer({
            firstName,
            lastName,
            emailAddress,
            phoneNumber,
            street,
            street2,
            city,
            state,
            country,
            zip,
            birthday: birthday,
            customerExtraInformations,
        }, 0, tenantId)
            .then((response) => {
                setPleasWaitPopup(false);
                getDataFromCustomer(response?.id, localAddress);
                setCurrentPage();
            })
            .catch((error) => {
                setPleasWaitPopup(false);
                console.error("Error:", error);
            });
    };


    return (
        <>
            <form onSubmit={findCustomer} className="w-full flex flex-col md:p-6">
                <div
                    className="flex flex-row items-center gap-1 w-full select-none cursor-pointer"
                    onClick={() => setExistingCustomer(!existingCustomer)}
                >
                    <FontAwesomeIcon
                        icon={existingCustomer ? faAngleDown : faAngleRight}
                        style={{ color: webData?.websiteHeaderColor }}
                    />
                    <h5
                        style={{ color: webData?.websiteHeaderColor }}
                        className="font-bold"
                    >
                        Returning Customer?
                    </h5>
                </div>

                <hr className="w-full bg-[#E4E7EC] mb-2" />

                {existingCustomer && (
                    <>
                        <div className="w-full px-2">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
                                <div className="space-y-2">
                                    <label className="text-xs font-medium">Email</label>
                                    <EmailValidatedComponent
                                        text={existingEmail}
                                        setText={setExistingEmail}
                                        required={true}
                                    />
                                </div>

                                <div className="space-y-2 relative">
                                    <label className="text-xs font-medium">Birthday</label>
                                    <CustomDateField
                                        value={existingBirthday}
                                        onChange={setExistingBirthday}
                                        dateFormat={webData?.dateFormat?.replace(/yyyy/g, 'YYYY')}
                                        className="w-full px-[8px] py-[8px] border rounded-md outline-none text-sm bg-transparent"
                                        showValidMessage={true}
                                        required={true}
                                    />
                                </div>
                            </div>
                        </div>

                        {notFound && (
                            <div className="px-2 text-red-500 text-sm mt-2">
                                We can't find any customer with that information
                            </div>
                        )}

                        <div className="mt-4 sm:mt-6 px-2">
                            <Button
                                btnType="submit"
                                name="Find Customer"
                                height="12px"
                                isBorderBtn={false}
                                isProcessing={false}
                                onClickHandler={() => { }}
                            />
                        </div>
                    </>
                )}
            </form>

            <div className="w-full mt-4 md:pl-[20px]">
                <div
                    className="flex flex-row items-center gap-1 w-full select-none"
                    onClick={() => setIsCustomerCollapse(!isCustomerCollapse)}
                >
                    <FontAwesomeIcon icon={isCustomerCollapse ? faAngleDown : faAngleRight} style={{ color: webData?.websiteHeaderColor }} />
                    <h5 style={{ color: webData?.websiteHeaderColor }}
                        className="font-bold">Customer Information</h5>
                </div>

                <hr className={`w-full bg-[#E4E7EC] mb-2`} />

                <form onSubmit={(e) => handleSubmit(e)}>
                    {
                        isCustomerCollapse && (
                            <>
                                <div className="w-full px-2">
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-6">
                                        {/* First Name - left */}
                                        <div className="col-span-1 md:col-start-1">
                                            <label className="text-xs font-medium">First Name</label>
                                            <input
                                                type="text"
                                                className="w-full px-2 py-2 border rounded-md outline-none text-sm bg-transparent"
                                                value={firstName}
                                                onChange={(e) => setFirstName(e.target.value)}
                                                required
                                            />
                                        </div>

                                        {/* Last Name - right */}
                                        <div className="col-span-1 md:col-start-2">
                                            <label className="text-xs font-medium">Last Name</label>
                                            <input
                                                type="text"
                                                className="w-full px-2 py-2 border rounded-md outline-none text-sm bg-transparent"
                                                value={lastName}
                                                onChange={(e) => setLastName(e.target.value)}
                                                required
                                            />
                                        </div>

                                        {/* Email Address - left */}
                                        <div className="col-span-1 md:col-start-1">
                                            <label className="text-xs font-medium">Email Address</label>
                                            <EmailValidatedComponent
                                                text={emailAddress}
                                                setText={setEmailAddress}
                                                required={true}
                                            />
                                        </div>

                                        {/* Phone Number - right */}
                                        <div className="col-span-1 md:col-start-2">
                                            <label className="text-xs font-medium">Phone Number</label>
                                            <PhoneNumberInput
                                                name="phoneNumber"
                                                value={phoneNumber}
                                                setValue={setPhoneNumber}
                                                fontSize="14px"
                                                paddingBlock="5px"
                                                required={true}
                                            />
                                        </div>

                                        {/* Street - left */}
                                        <div className="col-span-1 md:col-start-1">
                                            <label className="text-xs font-medium">Street</label>
                                            <input
                                                type="text"
                                                className="w-full px-2 py-2 border rounded-md outline-none text-sm bg-transparent"
                                                value={street}
                                                onChange={(e) => setStreet(e.target.value)}
                                                required
                                            />
                                        </div>

                                        {/* Street 2 - right */}
                                        <div className="col-span-1 md:col-start-2">
                                            <label className="text-xs font-medium">Street 2</label>
                                            <input
                                                type="text"
                                                className="w-full px-2 py-2 border rounded-md outline-none text-sm bg-transparent"
                                                value={street2}
                                                onChange={(e) => setStreet2(e.target.value)}
                                            />
                                        </div>

                                        {/* City - left */}
                                        <div className="col-span-1 md:col-start-1">
                                            <label className="text-xs font-medium">City</label>
                                            <input
                                                type="text"
                                                className="w-full px-2 py-2 border rounded-md outline-none text-sm bg-transparent"
                                                value={city}
                                                onChange={(e) => setCity(e.target.value)}
                                                required
                                            />
                                        </div>

                                        {/* State - right */}
                                        <div className="col-span-1 md:col-start-2">
                                            <label className="text-xs font-medium">State</label>
                                            <input
                                                type="text"
                                                className="w-full px-2 py-2 border rounded-md outline-none text-sm bg-transparent"
                                                value={state}
                                                onChange={(e) => setState(e.target.value)}
                                                required
                                            />
                                        </div>

                                        {/* Zip - left */}
                                        <div className="col-span-1 md:col-start-1">
                                            <label className="text-xs font-medium">Zip</label>
                                            <input
                                                type="text"
                                                className="w-full px-2 py-2 border rounded-md outline-none text-sm bg-transparent"
                                                value={zip}
                                                onChange={(e) => setzip(e.target.value)}
                                                required
                                            />
                                        </div>

                                        {/* Country - right */}
                                        <div className="col-span-1 md:col-start-2">
                                            <label className="text-xs font-medium">Country</label>
                                            <input
                                                type="text"
                                                className="w-full px-2 py-2 border rounded-md outline-none text-sm bg-transparent"
                                                value={country}
                                                onChange={(e) => setCountry(e.target.value)}
                                                required
                                            />
                                        </div>

                                        {/* Birthday - left */}
                                        <div className="col-span-1 md:col-start-1 relative space-y-2">
                                            <label className="text-xs font-medium">Birthday</label>
                                            <CustomDateField
                                                value={birthday}
                                                onChange={setBirthday}
                                                dateFormat={webData?.dateFormat?.replace(/yyyy/g, 'YYYY')}
                                                className="w-full px-[8px] py-[8px] border rounded-md outline-none text-sm bg-transparent"
                                                showValidMessage={true}
                                                required={true}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="w-full mt-4">
                                    <div
                                        className="flex flex-row items-center gap-1 w-full mt-8 md:mt-16 select-none"
                                        onClick={() => setIsExtra(!isExtra)}
                                    >
                                        <FontAwesomeIcon icon={isCustomerCollapse ? faAngleDown : faAngleRight} style={{ color: webData?.websiteHeaderColor }} />
                                        <h5 style={{ color: webData?.websiteHeaderColor }}
                                            className="font-bold">Extra Information</h5>
                                    </div>
                                    <hr className={`w-full bg-[#E4E7EC] mb-2`} />

                                    {
                                        isExtra && (
                                            <div className="w-full mt-2">

                                                <table className="min-w-full">
                                                    <tbody className="text-left">
                                                        <tr className={`border-b hidden md:table-row`}>
                                                            <th className={`w-[15%] text-[12px] font-semibold mb-2 py-2`}>Type</th>
                                                            <th className={`w-[25%] text-[12px] font-semibold mb-2 py-2`}>ID Number</th>
                                                            <th className={`w-[20%] text-[12px] font-semibold mb-2 py-2`}>Issued On</th>
                                                            <th className={`w-[20%] text-[12px] font-semibold mb-2 py-2`}>Exp. Date</th>
                                                            <th className={`w-[25%] text-[12px] font-semibold mb-2 py-2`}>File</th>
                                                        </tr>

                                                        {extraRow?.map((row: ExtraInformation) => {
                                                            return (
                                                                <AddIdentification
                                                                    key={row?.id}
                                                                    itemIndex={row?.id}
                                                                    birthDay={new Date(birthday)?.toDateString()}
                                                                    handleDeleteExtraRow={(index) => handleDeleteExtraRow(index)}
                                                                    row={row}
                                                                    changeOnExtraValue={(row) => changeOnExtraValue(row)}
                                                                    preferredDateFormat={webData?.dateFormat?.replace(/yyyy/g, 'YYYY')}
                                                                />
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                                <div
                                                    className="h-10 border-dashed border-t-0 border-l border-r border-b border-[#D5D4D8] mt-2 pt-1 flex justify-center items-center cursor-pointer"
                                                    onClick={() => {
                                                        handleAddExtraRow();
                                                    }}
                                                >
                                                    <p className="text-xs text-center cursor-pointer font-medium"
                                                        style={{ color: webData?.websiteHeaderColor }}
                                                    >
                                                        <FontAwesomeIcon icon={faPlus} className="text-xs text-center pt-1" />
                                                        Add another Identification
                                                    </p>
                                                </div>
                                            </div>
                                        )
                                    }

                                </div>

                                {/* Local Address */}
                                <div className="w-full mt-4">
                                    <label className="text-xs font-medium">Local Address</label>
                                    <input
                                        type="text"
                                        className="w-full px-[8px] py-[8px] border rounded-md outline-none text-sm bg-transparent"
                                        value={localAddress}
                                        onChange={(e) => setLocalAddress(e.target.value)}
                                    />
                                </div>

                                {/* Submit Button */}
                                <div className="flex gap-4 mt-6">
                                    <Button
                                        btnType="submit"
                                        name="Save"
                                        height="12px"
                                        isBorderBtn={false}
                                        isProcessing={false}
                                        onClickHandler={() => { }}
                                    />
                                </div>
                            </>
                        )}
                </form>

            </div>


        </>
    )
}

export default Customer